import { store } from '../app/store';
import { getApiGatewayUrl } from './deviceStatusHandler';

const apigClientFactory = require('aws-api-gateway-client').default;

export default (setResult: (success: boolean, r: any) => void) => {
    // extract endpoint from config
    const client = apigClientFactory.newClient({
        invokeUrl: getApiGatewayUrl(),
        retries: 3,
    });

    client
        .invokeApi(
            {},
            '/dynamicconfig',
            'GET',
            {
                headers: {
                    Authorization: store.getState().userData.userInfo!.jwt,
                },
            },
            null,
        )
        .then((response: any) => {
            const unescapedData = response.data.replace(/\\"/g, '"');
            const parsedData = JSON.parse(unescapedData);
            setResult(true, parsedData);
        })
        .catch((response: any) => {
            setResult(false, response);
        });
};
